import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { ActionIcon, Badge, Card, Center, Group, Text } from '@mantine/core';

import { TYPE_TO_READABLE_STRING_MAP } from 'constants/menuManagement';
import { DragHandleIconMd } from '@chownow/pantry/icons';
import { SORT_TYPE_LABEL_OVERRIDES } from './constants';

import { MenuElement } from './types';

export const BADGE_COLOR_MAP: Record<string, string> = {
  cuboh_category: 'ink',
  cuboh_main_item: 'blue',
  cuboh_modifier_group: 'pink',
  cuboh_modifier: 'yellow',
};

export interface SortableElementProps {
  element: MenuElement;
  index: number;
}

export default function SortableElement({ element, index }: SortableElementProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: element.uuid,
  });
  const label =
    SORT_TYPE_LABEL_OVERRIDES[element.itemType] ||
    TYPE_TO_READABLE_STRING_MAP[element.itemType as keyof typeof TYPE_TO_READABLE_STRING_MAP];

  const badgeColor = BADGE_COLOR_MAP[element.itemType];

  return (
    <Card
      p="sm"
      withBorder
      radius="xs"
      variant="outline-secondary"
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.7 : 1,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...attributes}
    >
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap="xs" wrap="nowrap" style={{ flex: 1, minWidth: 0 }}>
          <Badge variant={badgeColor} size="xs">
            {label} {index + 1}
          </Badge>
          <Text
            variant="sublabel-sm"
            truncate
            style={{
              flex: 1,
              minWidth: 0,
            }}
          >
            {element.name}
          </Text>
        </Group>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Center {...listeners} style={{ cursor: 'grab', flexShrink: 0 }}>
          <ActionIcon>
            <DragHandleIconMd />
          </ActionIcon>
        </Center>
      </Group>
    </Card>
  );
}
